// extracted by mini-css-extract-plugin
export default {"container":"mYqhR2Z1X5Wo5U7DzxIV"};